import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { useSortLoading } from '@op/models/commonLoading/useSortLoading';
import { useEffect, useMemo, useState } from 'react';
import { SortLoadingKeysType } from '../type';
import {
  getWeeklyVersionImplement,
  getWeeklyVersionSummary,
  saveWeeklyVersionImplement,
  saveWeeklyVersionSummary,
  getWeeklyVersionUGCSummary,
  saveWeeklyVersionUGCSummary,
} from '@op/services';

export type AiSummaryRichPropsType = {
  filter: any;
  summary_type?: 'ugc_video_summary';
  RichModuleKey?: SortLoadingKeysType;
};

export function useAiSummaryRichText({
  filter,
  summary_type,
  RichModuleKey,
}: AiSummaryRichPropsType) {
  const { finishLoading } = useSortLoading<SortLoadingKeysType>();
  const [richText, setRichText] = useState<any>([]);
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });

  useEffect(() => {
    if (!filter) return;
    setRichText([]);
    const requestFunc =
      summary_type === 'ugc_video_summary'
        ? getWeeklyVersionUGCSummary
        : getWeeklyVersionSummary;
    wrapperCancelRequest(requestFunc, filter)
      .then(data => {
        setRichText([
            {
              text: data.id,
              value: data.id,
              summary: data.summary || "",
              summaryCn: data.summary || "",
            },
          ]);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        if (RichModuleKey) {
          finishLoading(RichModuleKey, filter.module_id);
        }
      });
  }, [filter]);

  function modifyRichText(params: any) {
    const requestFunc =
      summary_type === 'ugc_video_summary'
        ? saveWeeklyVersionUGCSummary
        : saveWeeklyVersionSummary;
    const realParams =
      summary_type === 'ugc_video_summary' ? { ...params, ...filter } : params;
    return requestFunc({ data: realParams })
      .then(() => true)
      .catch(e => {
        console.log(e);
        return false;
      });
  }

  const isEmpty = useMemo(() => {
    return richText.length === 0;
  }, [richText]);

  return {
    richText,
    setRichText,
    modifyRichText,
    loading,
    isEmpty,
  };
}

export function useExecutionRichText({
  filter,
  RichModuleKey,
}: {
  filter: any;
  RichModuleKey?: SortLoadingKeysType;
}) {
  const { finishLoading } = useSortLoading<SortLoadingKeysType>();
  const [richText, setRichText] = useState<any>([]);
  const { wrapperCancelRequest, loading } = useCancelRequestHook({
    defaultLoading: true,
  });

  useEffect(() => {
    if (!filter) return;
    setRichText([]);
    wrapperCancelRequest(getWeeklyVersionImplement, filter)
      .then(data => {
        setRichText([
          {
            text: data?.id || 'A',
            value: data?.id || 'B',
            summary: data?.content || '',
            summaryCn: data?.content || '',
          },
        ]);
      })
      .catch(console.error)
      .finally(() => {
        if (RichModuleKey) {
          finishLoading(RichModuleKey, filter.module_id);
        }
      });
  }, [filter]);

  function modifyRichText(params: any) {
    return saveWeeklyVersionImplement({ data: { ...params, ...filter } })
      .then(() => true)
      .catch(() => false);
  }

  const isEmpty = useMemo(() => {
    return richText.length === 0;
  }, [richText]);

  return {
    richText,
    modifyRichText,
    loading,
    isEmpty,
  };
}
